import deviceEffects from './device.effects';

export default deviceEffects;
